module.exports = __webpack_public_path__ + "img/45.5f8797e8.png";